import {ViewStream, safeClone} from 'spyne';
import PricingItemTmpl from './templates/pricing-item.tmpl.html';

export class PricingItemView extends ViewStream {

    constructor(props={}) {
        props.class = 'pricing-item';
        props.data.__cms__isProxy = true;
      //props.data = safeClone({data: props.data});

        //console.log("ITEM VIEW",props.role,props.data);
        props.template = PricingItemTmpl;
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onRendered() {

    }

}

